import React from 'react'
import axios from 'axios'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import { withStyles } from '@material-ui/core/styles'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import FeedbackButton from '../../img/icons/feedback.svg'

import { API } from '../../utils/constants'

import styles from './styles'

class Feedback extends React.Component {
  state = {
    formdata: {
      name: '',
      email: '',
      msg: '',
    },
  }

  onChange = e => {
    let formdata = this.state.formdata
    formdata[e.target.id] = e.target.value
    this.setState({ formdata: formdata })
  }

  submitForm = post => {
    let formdata = this.state.formdata

    axios
      .post(API.enquiry, {
        mtype: 'Feedback',
        template: 'feedback',
        name: formdata.name,
        email: formdata.email,
        msg: formdata.msg,
        item: post,
      })
      .then(response => {
        toast.success('Your feedback has been sent, thanks.')
      })
  }

  render() {
    const { classes, post } = this.props
    const { formdata } = this.state
    return (
      <div className={classes.feedback}>
        <ToastContainer />

        <div className={classes.contents}>
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<FeedbackIcon />}>
              <Grid container spacing={40}>
                <Grid item xs={12}>
                  <Typography variant="subheading">Get in touch</Typography>
                </Grid>
              </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <form noValidate autoComplete="off">
                <input name="uid" type="hidden" value={post.uid} />
                  <TextField
                    id="name"
                    label="Name"
                    margin="normal"
                    value={formdata.name}
                    onChange={e => this.onChange(e)}
                  />
                  <TextField
                    id="email"
                    label="Email"
                    margin="normal"
                    value={formdata.email}
                    fullWidth={true}
                    onChange={e => this.onChange(e)}
                  />
                  <TextField
                    id="msg"
                    label="Comment"
                    fullWidth={true}
                    margin="normal"
                    rows={5}
                    multiline
                    value={formdata.msg}
                    onChange={e => this.onChange(e)}
                  />
                <Button
                  size={'small'}
                  variant={'raised'}
                  className={classes.feedbackFormSubmit}
                  onClick={() => this.submitForm(post.uid)}
                >
                  Post form
                </Button>
              </form>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      </div>
    )
  }
}

const FeedbackIcon = () => <img src={FeedbackButton} />

export default withStyles(styles)(Feedback)



// WEBPACK FOOTER //
// ./src/components/feedback/index.js